 (function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.dades.controller:DadesCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.dades')
    .controller('EntitatsMainSubmainDadesCtrl', EntitatsMainSubmainDadesCtrl);

  function EntitatsMainSubmainDadesCtrl(entitatData,$window, $rootScope, $stateParams, $locale, $state, HelperFactory,UploadFileConstants,$cookies,$scope,AdmConstant,UploadFactory,Notification) {
    var vm = this;
    vm.ctrlName = 'EntitatsMainSubmainDadesCtrl';

    vm.entitat=entitatData.data;
    vm.edit = edit;
    vm.deleteElem = deleteElem;


    function edit(){
      HelperFactory.setParams($stateParams, {'isNew': false, 'idEntitat': vm.entitat.id});
      $state.go('entitats.main.submain.formulari', $stateParams, {'reload': 'entitats.main.submain'});
    }



    function deleteElem() {
      $window.scrollTo(0, 0);
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
      $rootScope.$broadcast('entitats.main.llista.delete', vm.entitat.id);
    }


    if (angular.isUndefined($stateParams.idEntitat) || $stateParams.idEntitat === null || !$stateParams.idEntitat) {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
      $state.go('entitats.main', $stateParams, {'reload': 'entitats.main.submain'});

    }
    else {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': true});
    }


    vm.size = UploadFileConstants.SIZE_MINIMAL;
    vm.files = [];
    vm.errFiles = [];

    vm.chunkSize = angular.isUndefined($rootScope.chunkSize) ? UploadFileConstants.CHUNKSIZE : $scope.chunkSize;
    vm.maxSize = angular.isUndefined($rootScope.maxSize) ? UploadFileConstants.MAX_SIZE_UPLOAD_IMAGE : $scope.maxSize;
    vm.showOnlyIcon = angular.isUndefined($rootScope.showOnlyIcon) ? false : $scope.showOnlyIcon;
    vm.iconLeft = angular.isUndefined($rootScope.iconLeft) ? undefined : $scope.iconLeft;
    vm.iconRight = angular.isUndefined($rootScope.iconRight) ? undefined : $scope.iconRight;
    vm.ngDisabled = angular.isUndefined($rootScope.ngDisabled) ? false : $rootScope.ngDisabled;

    vm.onFinishFunction = onFinishUpload;
    vm.uploadFile       = uploadFile;
    vm.fitxercarrega = undefined;



    function cleanForm() {
      vm.files = [];
      vm.errFiles = [];
    }


    function onFinishUpload(objFile, response) {
          $rootScope.$broadcast('$deactivateLoader');
          cleanForm();
          vm.fitxercarrega = undefined;
          Notification.success('GENERIC_SUCCESS');
    }


    function onErrorUpload(objFile, error) {
          $rootScope.$broadcast('$deactivateLoader');
          Notification.processMessage(error.data);
          vm.files = [];
          cleanForm();
          vm.fitxercarrega = undefined;
    }

    function uploadFile() {
      $rootScope.$broadcast('$activateLoader');

      if (angular.isUndefined(vm.files) || vm.files.length === 0) {
        return;
      }

      var oldNewFileId;
      if (!angular.isUndefined(vm.fitxercarrega)) {
          oldNewFileId = vm.fitxercarrega.fields.newFileId;
      }

      var objFile = vm.files[0];
      vm.fitxercarrega = objFile;
      objFile.fields = {
        newFileId: HelperFactory.uniqueMoment(),
      };
      objFile.chunkSize = vm.chunkSize;
      objFile.sizeUrl = 'ok.html'+'?newFileId='+objFile.fields.newFileId+'&name='+objFile.file.name;
      objFile.baseUrl = '/api/' ;
      objFile.controllerUrl = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'entitats' + '/' + vm.entitat.id + '/llicenciesusuaris/upload';
      objFile.headers = { 'authsecurity' : $cookies.get('authsecurity'), 'x-api-version' :  AdmConstant.SERVER_ADMINISTRACIO_VERSION};

      UploadFactory.uploadFile(objFile, onFinishUpload,onErrorUpload);
    }

  }
}());
